module.exports = __webpack_public_path__ + "static/img/home_bottom_01.b7169b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_bottom_01.png
// module id = 625Z
// module chunks = 1